import axios from "axios";
import { errorActions } from "../helpers/auth_helper";

export async function syncSingleKylasDeal(payload: {
  lead_id?: string | null;
  estimate_id?: number;
  user_id?: string;
}): Promise<{ success: boolean; message: string; deal_id?: string } | undefined> {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/kylas/sync-estimate/`, payload)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error syncing deal to Kylas");
        return undefined;
      });
  } catch {
    return undefined;
  }
}
